var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.storeStates.global.isLoading)?_c('div',{staticClass:"bg-info d-flex justify-content-center pt-5",staticStyle:{"position":"absolute","top":"0","bottom":"0","left":"0","right":"0","height":"100%","padding-top":"50%","z-index":"999","opacity":"0.8"}},[_c('b-spinner',{attrs:{"label":"Working"}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }